import styled from "styled-components";

export const Header2Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 1400px;
  align-self: center;
`;
